import { fetcher } from '@/api/fetcher/fetcher'

function fetchRoles(includePermissions = true) {
  const searchParams = {
    include: includePermissions ? 'permissions' : 'createdBy,updatedBy,users_count',
  }
  return fetcher({
    url: `/roles`,
    options: { method: 'GET', searchParams },
  })
}

export { fetchRoles }
